import { render, staticRenderFns } from "./etims-setup.vue?vue&type=template&id=ce455abe&scoped=true"
import script from "./etims-setup.vue?vue&type=script&lang=js"
export * from "./etims-setup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce455abe",
  null
  
)

export default component.exports